import { ref, watch } from 'vue';
import { defineStore } from 'pinia';
import { useStepsStore } from '@/widgets/Wizard/stores/steps';
import { MINUTES, SECONDS } from '@/widgets/Wizard/models/time';

export const useRestartWizardStore = defineStore('booking-wizard/restart-wizard', () => {
    const inactiveTimeout = 5 * MINUTES; // Amount of milliseconds it takes for the restart popup to show up
    const resetTimeout = 30 * SECONDS; // Amount of milliseconds it takes for the restart popup to automatically restart the wizard

    const stepsStore = useStepsStore();

    // State
    // @ts-ignore
    const checkerHandle = ref<ReturnType<typeof setTimeout>>(0);
    // @ts-ignore
    const resetHandle = ref<ReturnType<typeof setTimeout>>(0);

    const showRestartPopup = ref(false);

    // Getters

    // Actions
    const startRestartTimer = () => {
        checkerHandle.value = setTimeout(() => {
            showRestartPopup.value = true;
        }, inactiveTimeout);
    };

    const stopRestartTimer = () => {
        clearTimeout(checkerHandle.value);
        clearTimeout(resetHandle.value);

        // @ts-ignore
        checkerHandle.value = 0;
        // @ts-ignore
        resetHandle.value = 0;
    };

    const reset = () => {
        stopRestartTimer();
        showRestartPopup.value = false;
    };

    watch(showRestartPopup, () => {
        if (!showRestartPopup.value) {
            clearTimeout(resetHandle.value);
            // @ts-ignore
            resetHandle.value = 0;

            return;
        }

        resetHandle.value = setTimeout(() => {
            stepsStore.reset();
        }, resetTimeout);
    });

    return {
        // State
        checkerHandle,
        resetHandle,
        showRestartPopup,

        // Getters

        // Actions
        startRestartTimer,
        stopRestartTimer,
        reset,
    };
});
